import Typography from '../../../../../../../components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../utils/testIds/CatalogProducts.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { CatalogSectionSortCriterionEnum } from '../../../../../enums/catalogSectionSortCriterion.enum';
import { CatalogViewGroupBy } from '../../../view/catalogView.types';
import { resolveGroupOptions } from '../../../view/resolveViewCombination';
import { CatalogViewSettingsContentProps } from '../catalogViewSettings.types';
import CatalogViewClassificationTypeRow from './CatalogViewClassificationTypeRow';
import CatalogViewSettingsRow from './CatalogViewSettingsRow';
import CatalogViewValueSelect from './CatalogViewValueSelect';

interface CatalogViewGroupSectionProps {
  groupBy: CatalogViewGroupBy;
  sortCriterion: CatalogSectionSortCriterionEnum;
  groupTargetId: string | null;
  isLoading: boolean;
  isGroupTargetMissing: boolean;
  notGroupedWarning: CatalogViewSettingsContentProps['notGroupedWarning'];
  onGroupByChange: (groupBy: CatalogViewGroupBy) => void;
  onGroupTargetIdChange: (groupTargetId: string | null) => void;
}

const CatalogViewGroupSection = ({
  groupBy,
  sortCriterion,
  groupTargetId,
  isLoading,
  isGroupTargetMissing,
  notGroupedWarning,
  onGroupByChange,
  onGroupTargetIdChange,
}: CatalogViewGroupSectionProps) => {
  const { translate } = useTranslation();

  return (
    <>
      <CatalogViewSettingsRow label={LangEnum.GLOBAL_GROUP_BY}>
        <CatalogViewValueSelect
          label={LangEnum.GLOBAL_GROUP_BY}
          value={groupBy}
          options={resolveGroupOptions({ sortCriterion, groupBy })}
          testId={CatalogProductsTestIds.VIEW_GROUP_BY_SELECT}
          disabled={isLoading}
          onChange={onGroupByChange}
        />
      </CatalogViewSettingsRow>
      {groupBy === CatalogViewGroupBy.CLASSIFICATION_TYPE && (
        <CatalogViewClassificationTypeRow
          testId={CatalogProductsTestIds.VIEW_GROUP_CLASSIFICATION_TYPE_SELECT}
          value={groupTargetId}
          hasError={isGroupTargetMissing}
          onChange={onGroupTargetIdChange}
        />
      )}
      {notGroupedWarning && (
        <Typography
          variant="caption"
          color="text.secondary"
          testId={CatalogProductsTestIds.VIEW_NOT_GROUPED_WARNING}
        >
          {translate(notGroupedWarning)}
        </Typography>
      )}
    </>
  );
};

export default CatalogViewGroupSection;
